var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-5 h-5 rounded rounded-full cursor-pointer",class:_vm.activeClass,attrs:{"title":_vm.activeTitle},on:{"click":_vm.onSwitch}},[(_vm.icon)?[_c('img',{attrs:{"src":_vm.icon}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }